window.addEventListener("DOMContentLoaded", () => {
  updateSelectedValueLabel();

  // Update the label when any swatch is clicked
  const swatches = document.querySelectorAll('.siblings__swatch');
  swatches.forEach(swatch => {
    swatch.addEventListener('click', () => {
      updateSelectedValueLabel();
    });
  });
});

function updateSelectedValueLabel() {
  const currentSwatch = document.querySelector('.siblings__swatch[aria-current="true"]');

  if (!currentSwatch) {
    return; // Exit if no current swatch is selected
  }

  const siblingsButton = currentSwatch.querySelector('.siblings__button');
  const swatchValue = siblingsButton.getAttribute('data-swatch');

  // Find the correct legend where we need to place the value
  const closestFieldset = currentSwatch.closest('fieldset');
  const swatchValueLabel = closestFieldset.querySelector('.radio__legend__value');

  if (swatchValueLabel) {
    swatchValueLabel.innerHTML = swatchValue;
  }
}
